import { render, staticRenderFns } from "./sfkc.vue?vue&type=template&id=21766cec&scoped=true&"
import script from "./sfkc.vue?vue&type=script&lang=js&"
export * from "./sfkc.vue?vue&type=script&lang=js&"
import style0 from "./sfkc.vue?vue&type=style&index=0&id=21766cec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21766cec",
  null
  
)

export default component.exports